<template>
  <div class="captcha mt-4">
    För att vara säker på att du inte är en robot skulle vi vilja be dig räkna ut talet nedan.
    <div class="captcha-input flex flex-row mt-4 items-center">
      <label for="captcha" v-html="textCaptcha" class="font-proxima-nova text-b2 mr-4"></label>
      <input
        id="captcha"
        v-model="inputCaptcha"
        maxlength="2"
        type="text"
        class="rounded-md text-form-input border-gray-60 border-[1px] py-2 px-4 w-16"
        @keyup="checkInput($event)" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['name'],
  data() {
    return {
      sumCaptcha: null,
      textCaptcha: '',
      inputCaptcha: '',
    };
  },
  methods: {
    getRandom: function () {
      return Math.ceil(Math.random() * 20);
    },
    createSum: function () {
      var randomNum1 = this.getRandom(),
        randomNum2 = this.getRandom();
      this.sumCaptcha = randomNum1 + randomNum2;
      this.textCaptcha = randomNum1 + ' + ' + randomNum2 + ' = ';

      this.inputCaptcha = '';
    },
    checkInput: function (el) {
      this.$emit('change', this.inputCaptcha !== '' && this.inputCaptcha == this.sumCaptcha);
    },
  },
  created() {
    this.createSum();
  },
};
</script>

<style scoped lang="scss">

label {
  display: inline-block;
}


input, textarea {

  &:focus-within {
    outline: 2px solid $abgblue;
  }
}
</style>
